import { StudentOrderList } from "./Orders.list";

const resource = {
    list: StudentOrderList
}

export default resource